var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"min-h-full flex bg-main-layout"},[_c('Sidebar',{staticClass:"xs:hidden md:block"}),_c('div',{staticClass:"w-full h-full flex flex-col items-center mt-0"},[_c('Header'),_c('div',{staticClass:"w-full px-4 md:px-8 transition-padding",class:{
        'md:pl-222px': !_vm.sidebarMini,
        'md:pl-92px': _vm.sidebarMini,
        'mt-76px': _vm.showHeader,
      }},[_c('router-view')],1)],1),_c('MobileMenu',{staticClass:"flex md:hidden"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }